const postCloneChecklistBySite = {
  toastr: 'Cloned Checklist',
  toastr1: 'The Model has been updated successfully'
};

export default postCloneChecklistBySite;
